import React from 'react';
import { components as ReactSelectComponents, MultiValueProps } from 'react-select';
import { ITreeSelectExtendedOption, TTreeSelectProps, TGroupedChildrenByParents } from './interfaces';

interface IProps<SOption> extends MultiValueProps<SOption> {
  component: React.ComponentType<MultiValueProps<SOption>>,
  groupedChildrenByParents: TGroupedChildrenByParents,
}

const TreeSelectMultiValue = <SOption extends ITreeSelectExtendedOption, >({
  component: Component,
  groupedChildrenByParents,
  ...otherProps
}: IProps<SOption>) => {
  const data = otherProps.data as SOption;
  const selectProps = otherProps.selectProps as TTreeSelectProps<SOption>;
  const selectedOptions = selectProps.value as SOption[];

  const childrenValues = groupedChildrenByParents.get(data.parent)?.optionsValues || [];
  const selectedValues = (selectedOptions).map(({ value }) => value);
  const isAllChildrenSelected = childrenValues.every((child) => selectedValues.includes(child));
  const isLastChild = data.value === childrenValues.at(-1);

  if (isAllChildrenSelected && !isLastChild && data.parent) {
    return null;
  }

  const option = isLastChild && isAllChildrenSelected
    ? (otherProps.options as SOption[]).find(({ label }) => label === data.parent)
    : data;

  return (
    <ReactSelectComponents.MultiValue { ...otherProps }>
      { Component ? (<Component { ...otherProps } data={ option } />) : data.label }
    </ReactSelectComponents.MultiValue>
  );
};

export default TreeSelectMultiValue;
